// extracted by mini-css-extract-plugin
module.exports = {"ChangePasswordForm":"ChangePasswordForm_ChangePasswordForm__3plEU","errorText":"ChangePasswordForm_errorText__HeNUH"};